import { Cloudinary } from "@cloudinary/url-gen";

const CloudinaryService = {
  instance: null,

  init() {
    if (!this.instance) {
      this.instance = new Cloudinary({
        cloud: {
          cloudName: "ooblee"
        },
        url: {
          secure: true
        }
      });
    }
    return this.instance;
  },

  getInstance() {
    if (!this.instance) {
      this.init();
    }
    return this.instance;
  },

  getConfig() {
    return {
      cloudName: "ooblee",
      apiKey: "966268669875632",
      apiSecret: "thYtAg949mBcU3dDgsPjsZVas_E"
    };
  }
};

export default CloudinaryService;
